module.exports = __webpack_public_path__ + "img/biangeng.7a3b43b9.png";